export function findTopMostDialog(root) {
    const allDialogs = root.querySelectorAll(`[role="dialog"]`);
    return [...allDialogs].reverse().find((dialog) => !dialog.closest(`[aria-hidden="true"]`));
    // TODO: also detect fully hidden using getComputedStyle or something
}
